"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  frame: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    width: "xh8yej3",
    $$css: true
  },
  button: {
    display: "x78zum5",
    justifyContent: "xl56j7k",
    width: "xh8yej3",
    minHeight: "xsejkeq",
    $$css: true
  },
  roomy: {
    zoom: "x13auhzm",
    width: "x1843oig",
    $$css: true
  },
  feedback: {
    display: "x1lliihq xjl7jj",
    marginTop: "xhj8ucd",
    marginBottom: "xat24cr",
    fontSize: "xyr29y3",
    color: "x10kmngs",
    $$css: true
  }
};